import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserContext } from "../context/userContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }else{
    if(location.pathname === "/" ){
        return <Navigate to="/dashboard" replace />;
    }
  }
  return children;
};

export default ProtectedRoute;
